import { AuthService } from './../../Services/auth.service';
import { LifecycleHooks } from '@angular/compiler/src/lifecycle_reflector';
import { GroupService } from './../../Services/group.service';
import { CourseriddenService } from './../../Services/courseridden.service';
import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-amount-ridden-per-group',
  template: require('./amount-ridden-per-group.component.html'),
  styles: [require('./amount-ridden-per-group.component.css')]
})
export class AmountRiddenPerGroupComponent implements OnInit {

  groups: any[] = [];
  selectedGroup: any;
  data: any[] = [];
  dates: any[] = [];
  selectedYear: number = 0;
  constructor(  private courseRiddenService:CourseriddenService, 
                private groupservice: GroupService,
                private auth: AuthService ) { }


  ngOnInit() {
    let currentDate = new Date(); 
    this.selectedYear = currentDate. getFullYear(); 

    this.groupservice.getGroups().subscribe( res => {
      this.groups = res;
      // console.log(this.groups);
    })

    this.courseRiddenService.getAllYears().subscribe ( res =>{
      this.dates = res.reverse();
    })
  }

  public SelectionChanged(){
    // console.log(this.selectedGroup);
    this.courseRiddenService.getCountOfMembersPerGroup(this.selectedGroup, this.selectedYear).subscribe( res => {
      this.data = res;
      // console.log(this.data);
    })  
  }
  public downloadCoursesRiddenPerGroup(){
    this.courseRiddenService.downloadCoursesRiddenPerGroup(this.selectedGroup, this.selectedYear).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/amount-ridden-per-group/amount-ridden-per-group.component.ts